module.exports = __webpack_public_path__ + "static/media/alladin4.571b1d6c.gif";